import { ReferenceDataSetSource, ReferenceDataSetLinkSet } from './reference-data.types';

export const tables : ReferenceDataSetSource = {
	productCategory: [
		{ code: "UAE01", name: "Umbrella Assurance Extra" }, 
		{ code: "UBU01", name: "Umbrella Business" }, 
	],

	policyStatusCode: [
		{ code: "IF", name: "In Force" }, 
		{ code: "OOF", name: "Out of Force" }, 
		{ code: "PIF", name: "Pending in Force" }, 
		{ code: "QFA", name: "Quote for Alteration" }, 
		{ code: "CPUP", name: "Contractually Paid Up" }, 
		{ code: "IFWP", name: "In Force under Waiver of Premium" }, 
	],

	premiumType: [
		{ code: "Current", name: "Current" }, 
		{ code: "Proposed", name: "Proposed" }, 
	],

	paymentFrequency: [
		{ code: "MONT01", name: "Monthly" }, 
		{ code: "YEAR01", name: "Yearly" }, 
		{ code: "FORT01", name: "Fortnightly" }, 
		{ code: "WEEK01", name: "Weekly" }, 
		{ code: "HAYE01", name: "Half-yearly" }, 
	],

	marketingCampaign: [
		{ code: "MCOLS01", name: "OnePath Life Standard" }, 
		{ code: "MCFUN01", name: "Funeral" }, 
		{ code: "MCANZ01", name: "ANZ" }, 
		{ code: "MCSX01", name: "Southern Cross" }, 
		{ code: "MCCHDI01", name: "Chubb Direct" }, 
	],

	gender: [
		{ code: "MALE", name: "Male" }, 
		{ code: "FEMALE", name: "Female" }, 
	],

	smoker: [
		{ code: "SMOK", name: "Smoker" }, 
		{ code: "NSMK", name: "Non Smoker" }, 
	],

	coverageType: [
		{ code: "LIFE01", name: "Life Cover" }, 
		{ code: "LIIN01", name: "Life Income Cover" }, 
		{ code: "TRAU01", name: "Trauma Cover" }, 
		{ code: "TPDT01", name: "TPD on Trauma" }, 
		{ code: "CODI01", name: "Complete Disablement" }, 
		{ code: "INCO01", name: "Income Cover" }, 
		{ code: "LOEA01", name: "Loss of Earnings" }, 
		{ code: "MORE01", name: "Mortgage Repayment Cover" }, 
		{ code: "REDU01", name: "Redundancy Cover" }, 
		{ code: "EXPE01", name: "Expenses Cover" }, 
		{ code: "SPIN01", name: "Specific Injury" }, 
		{ code: "PREM01", name: "Premium Cover" }, 
		{ code: "TRCH01", name: "Trauma Child" }, 
		{ code: "FUNE01", name: "Funeral Cover" }, 
		{ code: "TBC", name: "BUSINESS" }, 
	],

	coverageCode: [
		{ code: "uLife", name: "Umbrella Life Cover" }, 
		{ code: "uLifeIncome", name: "Umbrella Life Income Cover" }, 
		{ code: "uTraumaA", name: "Umbrella Trauma Accelerated" }, 
		{ code: "uTPDonTraumaA", name: "Umbrella TPD on Trauma Accelerated" }, 
		{ code: "uTraumaS", name: "Umbrella Trauma Standalone" }, 
		{ code: "uTPDonTraumaS", name: "Umbrella TPD on Trauma Standalone" }, 
		{ code: "uCompDisA", name: "Umbrella Complete Disablement Accelerated" }, 
		{ code: "uCompDisS", name: "Umbrella Complete Disablemen Standalone" }, 
		{ code: "uIncome", name: "Umbrella Income Cover" }, 
		{ code: "uLOE", name: "Umbrella Loss of Earnings Cover" }, 
		{ code: "uMRepaymentCov", name: "Umbrella Mortgage Repayment Cover" }, 
		{ code: "uRedundancy", name: "Umbrella Redundancy Cover " }, 
		{ code: "uSpecificInjury", name: "Umbrella Specific Injury " }, 
		{ code: "uPremium", name: "Umbrella Premium Cover " }, 
		{ code: "uTraumaChild", name: "Umbrella Trauma Child" }, 
		{ code: "AEBLife", name: "AEB Business Life Cover" }, 
		{ code: "AEB", name: "TraumaA	Business Trauma Accelerated " }, // NOSONAR - duplicate code is intentional reference data
		{ code: "AEB", name: "TraumaS	Business Trauma Standalone" },
		{ code: "AEBCompDisA", name: "BusinessComplete Disablement Accelerated " }, 
		{ code: "AEBMDisStandard", name: "Monthly Disability Cover" }, 
		{ code: "AEBMDisStartUp", name: "Start-up Monthly Disability Cover" }, 
		{ code: "AEBBusO/Heads", name: "Monthly Disability Cover - Business Overheads" }, 
		{ code: "AEBFarmConsult", name: "Monthly Disability Cover - Farm Consultancy " }, 
		{ code: "AEBSpecInjury", name: "Business Specfic Injury " }, 
		{ code: "AEBPremCover", name: "Business Premium Cover" }, 
		{ code: "AEBKPMonthSA1", name: "KP Month Sum 1 " }, 
		{ code: "AEBKPMonthSA2", name: "KP Month Sum 2" }, 
		{ code: "AEBKPMonthSA3", name: "KP Month Sum 3" }, 
		{ code: "AEBKPMonthSA4", name: "KP Month Sum 4" }, 
		{ code: "AEBKPMonthSA5", name: "KP Month Sum 5" }, 
		{ code: "AEBKPMonthSA6", name: "KP Month Sum 6" }, 
		{ code: "AEBKPMonthSA7", name: "KP Month Sum 7" }, 
		{ code: "AEBKPMonthSA8", name: "KP Month Sum 8" }, 
		{ code: "AEBKPMonthSA9", name: "KP Month Sum 9" }, 
		{ code: "AEBKPMonthSA10", name: "KP Month Sum 10" }, 
		{ code: "AEBKPMonthSA11", name: "KP Month Sum 11" }, 
		{ code: "AEBKPMonthSA12", name: "KP Month Sum 12" }, 
		{ code: "mLife", name: "Modular Life Cover" }, 
		{ code: "mtraumaS", name: "Modular Trauma Standalone" }, 
		{ code: "mExpensesCov", name: "Modular Expenses Cover" }, 
		{ code: "mPremCover", name: "Modular Premium Cover" }, 
		{ code: "Funeral", name: "Cover	Funeral Cover" }, 
	],

	coverageStatusCode: [
		{ code: "IF", name: "In Force" }, 
		{ code: "OOF", name: "Out of Force" }, 
		{ code: "PIF", name: "Pending" }, 
		{ code: "QFA", name: "Quote for Alteration" }, 
		{ code: "CPUP", name: "Contractually Paid Up" }, 
		{ code: "IFWP", name: "In Force under Waiver of Premium" }, 
	],

	premiumReviewPeriod: [
		{ code: "YRT", name: "Yearly Renewal Term" }, 
		{ code: "5YR", name: "5 Year Renew Term" }, 
		{ code: "5YR5P", name: "5 Year 5% Renew Term" }, 
		{ code: "10YR", name: "10 Year Renew Term" }, 
		{ code: "AGE65", name: "Level to Age 65" }, 
		{ code: "AGE70", name: "Level to Age 70" }, 
		{ code: "AGE75", name: "Level to Age 75" }, 
		{ code: "AGE80", name: "Level to Age 80" }, 
		{ code: "AGE100", name: "Level to Age 100" }, 
	],

	indexation: [
		{ code: "CPI", name: "Inflation Adjusted" }, 
		{ code: "CPI Linked", name: "CPI Linked" },
		{ code: "LEVEL", name: "Non-Inflation Adjusted" }, 
	],

	waitPeriod: [
		{ code: "4WEEKS", name: "4 Week Wait Period" }, 
		{ code: "8WEEKS", name: "8 Week Wait Period" }, 
		{ code: "13WEEKS", name: "13 Week Wait Period" }, 
		{ code: "26WEEKS", name: "26 Week Wait Period" }, 
		{ code: "52WEEKS", name: "52 Week Wait Period" }, 
		{ code: "104WEEKS", name: "104 Week Wait Period" }, 
		{ code: "6MONTHS", name: "6 Months" }, 
		{ code: "8 Weeks", name: "8 Week Wait Period" }, 
		{ code: "13 Weeks", name: "13 Week Wait Period" }, 
	],

	coverTerm: [
		{ code: "AGE65", name: "Age 65" }, 
		{ code: "AGE70", name: "Age 70" }, 
		{ code: "AGE75", name: "Age 75" }, 
	],

	coverType: [
		{ code: "OWN", name: "Own Cover" }, 
	],

	paymentTerm: [
		{ code: "6MONTHS", name: "6 Months" }, 
		{ code: "2YEAR", name: "2 Year" }, 
		{ code: "5YEAR", name: "5 Year" }, 
		{ code: "10YEAR", name: "10 Year" }, 
		{ code: "15YEAR", name: "15 Year" }, 
		{ code: "20YEAR", name: "20 Year" }, 
		{ code: "25YEAR", name: "25 Year" }, 
		{ code: "30YEAR", name: "30 Year" }, 
		{ code: "AGE65", name: "Age 65" }, 
		{ code: "AGE70", name: "Age 70" },  
		{ code: "AGE75", name: "Age 75" }, 
	],

	coverageOptionName: [
		{ code: "GIO01", name: "Guaranteed Insurability" }, 
		{ code: "HOPR01", name: "Hold Pricing" }, 
		{ code: "TUGI01", name: "Taken Up GIO" }, 
		{ code: "TUSE01", name: "Taken Up Special Event" }, 
		{ code: "TARI01", name: "Talisman Rider" }, 
		{ code: "LEDI01", name: "Legacy Discount" }, 
		{ code: "LIRE01", name: "Lifetime Reward" }, 
		{ code: "LIBU01", name: "Life Buyback" }, 
		{ code: "TRBU01", name: "Trauma Buyback" }, 
		{ code: "CAPL01", name: "Cancer Plus" }, 
		{ code: "RIDT01", name: "Rider Discount" }, 
		{ code: "CAFR01", name: "Campaign Free" }, 
		{ code: "OCTR01", name: "Optional Continous Trauma" }, 
		{ code: "OCDE01", name: "Occupation Definition" }, 
		{ code: "WAPE01", name: "Wait Period Extension" }, 
		{ code: "MEHR01", name: "Mental Health table: triction" }, 
		{ code: "INCT01", name: "Income Cover Type" }, 
		{ code: "DERE01", name: "Dependant Relative" }, 
		{ code: "EXOP01", name: "Extra Option" }, 
		{ code: "INTU01", name: "Income Take Up" }, 
		{ code: "REWP01", name: "Reduced Wait Period" }, 
		{ code: "SOIC01", name: "Sickness Only Income Cover" }, 
		{ code: "TPDI01", name: "Talisman Premium - Disability" }, 
		{ code: "TPPC01", name: "Talisman Premium - Premium Cover" }, 
		{ code: "TPTT01", name: "Talisman Premium - TPD on Trauma" }, 
		{ code: "LOEE01", name: "Loss of Earnings Extra" }, 
		{ code: "MODE01", name: "Mortgage Deluxe" }, 
		{ code: "LOTY01", name: "LOE Type" }, 
		{ code: "TPD01", name: "TPD" }
	],

	occupationClass: [
		{ code: 'OCC1', name: 'OCC1' },
		{ code: 'OCC2', name: 'OCC2' },
		{ code: 'OCC3', name: 'OCC3' },
		{ code: 'OCC4', name: 'OCC4' },
	],
	
	TPD: [
		{ code: 'YES', name: 'Yes' },
		{ code: 'NO', name: 'No' },
    ]
}

export const links : ReferenceDataSetLinkSet = [ 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "AGE70", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "AGE80", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "AGE100", coverageCode: "uLife" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uLife Income" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uLife Income" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uLife Income" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uLife Income" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "10YEAR", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "AGE70", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "AGE75", coverageCode: "uTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uTPDonTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uTPDonTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uTPDonTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uTPDonTraumaA" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "AGE70", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "AGE75", coverageCode: "uTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uTPDonTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uTPDonTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uTPDonTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uTPDonTraumaS" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "AGE70", coverageCode: "uCompDisA" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "AGE65", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "AGE70", coverageCode: "uCompDisS" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uIncome" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uIncome" }, 
	{ table: "premiumReviewPeriod", code: "5YR5P", coverageCode: "uIncome" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uIncome" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uLOE" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uMRepaymentCov" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uRedundancy " }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uSpecInjury" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "UTraumaChild" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "UTraumaChild" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "UTraumaChild" }, 
	{ table: "premiumReviewPeriod", code: "YRT", coverageCode: "uPremCover" }, 
	{ table: "premiumReviewPeriod", code: "5YR", coverageCode: "uPremCover" }, 
	{ table: "premiumReviewPeriod", code: "10YR", coverageCode: "uPremCover" }, 

	{ table: "waitPeriod", code: "6MONTHS", coverageCode: "uTPDonTraumaA" }, 
	{ table: "waitPeriod", code: "6MONTHS", coverageCode: "uTPDonTraumaS" }, 
	{ table: "waitPeriod", code: "6MONTHS", coverageCode: "uCompDisA" }, 
	{ table: "waitPeriod", code: "6MONTHS", coverageCode: "uCompDisS" }, 

	{ table: "coverTerm", code: "AGE65", coverageCode: "uIncome" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uIncome" }, 
	{ table: "coverTerm", code: "AGE65", coverageCode: "uMRepaymentCov" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uMRepaymentCov" }, 
	{ table: "coverTerm", code: "AGE65", coverageCode: "uPremCover" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uPremCover" }, 
	{ table: "coverTerm", code: "AGE65", coverageCode: "uLOE" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uLOE" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uTraumaA" }, 
	{ table: "coverTerm", code: "AGE75", coverageCode: "uTraumaA" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uTraumaS" }, 
	{ table: "coverTerm", code: "AGE75", coverageCode: "uTraumaS" }, 
	{ table: "coverTerm", code: "AGE65", coverageCode: "uCompDisA" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uCompDisA" }, 
	{ table: "coverTerm", code: "AGE65", coverageCode: "uCompDisS" }, 
	{ table: "coverTerm", code: "AGE70", coverageCode: "uCompDisS" }, 

	{ table: "paymentTerm", code: "6MONTHS", coverageCode: "uRedundancy" }, 
	{ table: "paymentTerm", code: "2YEAR", coverageCode: "uIncome" }, 
	{ table: "paymentTerm", code: "5YEAR", coverageCode: "uIncome" }, 
	{ table: "paymentTerm", code: "AGE65", coverageCode: "uIncome" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uIncome" }, 
	{ table: "paymentTerm", code: "2YEAR", coverageCode: "uMRepaymentCov" }, 
	{ table: "paymentTerm", code: "5YEAR", coverageCode: "uMRepaymentCov" }, 
	{ table: "paymentTerm", code: "AGE65", coverageCode: "uMRepaymentCov" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uMRepaymentCov" }, 
	{ table: "paymentTerm", code: "AGE75", coverageCode: "uTraumaA" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uTraumaA" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uTraumaS" }, 
	{ table: "paymentTerm", code: "AGE75", coverageCode: "uTraumaS" }, 
	{ table: "paymentTerm", code: "AGE65", coverageCode: "uTPDonTraumaA" }, 
	{ table: "paymentTerm", code: "AGE65", coverageCode: "uTPDonTraumaS" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uCompDisA" }, 
	{ table: "paymentTerm", code: "AGE75", coverageCode: "uCompDisA" }, 
	{ table: "paymentTerm", code: "AGE65", coverageCode: "uCompDisS" }, 
	{ table: "paymentTerm", code: "AGE70", coverageCode: "uCompDisS" }, 
]